import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { QuotationsRowItems } from '../../models/Quotations';
import useQuotations from '../../hooks/quotations/useQuotations';
import SnackbarUtils from '../../utils/SnackbarUtils';
import useConfirmDialog from '../../hooks/dialogs/useConfirmDialog';

export const QuotationsTableRow: React.FC<QuotationsRowItems> = (props) => {
    const { row, index, clickHandle, selected } = props;
    const isSelected = (name: string) => selected.indexOf(name) !== -1;
    const isItemSelected = isSelected(row.quoteID.toString());
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;
    const navigate = useNavigate();
    const quotations = useQuotations();
    const confirmDialog = useConfirmDialog();

    const editQuotation = () => {
        navigate('/quotation/' + row.quoteID);
    };

    const copyQuotation = () => {
        quotations
            // .copyQuotation(row.quoteID)
            .fakePromise()
            .then(() => {
                SnackbarUtils.success(t('MESSAGES.COPIED'));
                // TODO: forceRefresh
            })
            .catch(() => {
                SnackbarUtils.error(t('MESSAGES.COPIED_ERROR'));
            });
    };

    const toPDF = () => {
        // quotations.createPDFQuotation(row.quoteID)
    };

    const deleteQuotation = () => {
        quotations
            // .deleteQuotation(row.quoteID)
            .fakePromise()
            .then(() => {
                SnackbarUtils.success(t('MESSAGES.DELETED'));
                // TODO: forceRefresh
            })
            .catch(() => {
                SnackbarUtils.error(t('MESSAGES.DELETED_ERROR'));
            });
    };

    const handleDeleteProfile = () => {
        deleteQuotation();
    };

    const handleClickDelete = () => {
        confirmDialog.showDialog({
            title: t('QUOTATION_DELETE_CONFIRM_DIALOG.TITLE'),
            content: t('QUOTATION_DELETE_CONFIRM_DIALOG.CONTENT'),
            confirmText: t('QUOTATION_DELETE_CONFIRM_DIALOG.CONFIRM'),
            cancelText: t('QUOTATION_DELETE_CONFIRM_DIALOG.CANCEL'),
            onConfirm: () => handleDeleteProfile(),
        });
    };

    return (
        <>
            <TableRow
                hover
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                selected={isItemSelected}
            >
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                            'aria-labelledby': labelId,
                        }}
                        onClick={(event) =>
                            clickHandle(event, row.quoteID.toString())
                        }
                    />
                </TableCell>
                <TableCell
                    component="th"
                    id={labelId}
                    scope="row"
                    padding="none"
                >
                    {row.quoteID}
                </TableCell>
                <TableCell>{row.billToCustomerName}</TableCell>
                <TableCell>
                    {t('TABLE_ROW.QUOTE_COUNT', { count: row.count })}
                </TableCell>
                <TableCell>{row.orderDate}</TableCell>
                <TableCell>
                    <EditIcon
                        onClick={editQuotation}
                        sx={{ cursor: 'pointer' }}
                    />
                    <ContentCopyIcon
                        onClick={copyQuotation}
                        sx={{ cursor: 'pointer' }}
                    />
                    <PictureAsPdfIcon
                        onClick={toPDF}
                        sx={{ cursor: 'pointer' }}
                    />
                    <DeleteIcon
                        onClick={handleClickDelete}
                        sx={{ cursor: 'pointer' }}
                    />
                </TableCell>
                <TableCell align="right">{t('TABLE_ROW.DETAILS')}</TableCell>
            </TableRow>
        </>
    );
};
